module.exports = __webpack_public_path__ + "img/file02.05de403a.png";